import { render, staticRenderFns } from "./ContractLaunchDiscountForm.vue?vue&type=template&id=2a6f98e4&"
import script from "./ContractLaunchDiscountForm.vue?vue&type=script&lang=js&"
export * from "./ContractLaunchDiscountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports